// @flow

import type { State } from '../travelerInfo';
import type { Action } from '../../state';

export type RestaurantsTravelerInfo = {|
  date?: string,
  displayDate?: string,
  time?: string,
  partySize?: string,
  isDefault?: boolean,
|};

/**
 * Update the date in restaurants TravelerInfo.
 */
export const setEatTravelerDate = (date: Date, displayDate: string) => ({
  type: 'SET_EAT_TRAVELER_DATE',
  date,
  displayDate,
});

/**
 * Update the time in restaurants TravelerInfo.
 */
export const setEatTravelerTime = (time: string) => ({
  type: 'SET_EAT_TRAVELER_TIME',
  time,
});

/**
 * Update the party size in restaurants TravelerInfo.
 */
export const setEatTravelerPartySize = (partySize: string) => ({
  type: 'SET_EAT_TRAVELER_PARTY_SIZE',
  partySize,
});

export const setEatTravelerDefaultStatus = (isDefault: boolean) => ({
  type: 'SET_DEFAULT_STATUS',
  isDefault,
});

function formatDate(date: Date): string {
  const year = date.getFullYear();
  let month = date.getMonth() + 1;
  let day = date.getDate();

  if (day < 10) {
    day = `0${day}`;
  }
  if (month < 10) {
    month = `0${month}`;
  }
  return `${year}-${month}-${day}`;
}

const defaultState = Object.freeze({});

/**
 * Changes state depending on the action's type
 * @param state  global redux store State - defined in state.jsx, contains travelerInfo, which has RestaurantsTravelerInfo
 * @param action  global redux store Action - defined in state.jsx
 * @returns updated state
 */
export default (state: State = defaultState, action: Action): State => {
  switch (action.type) {
    case 'SET_EAT_TRAVELER_DATE':
      return {
        ...state,
        restaurants: {
          ...state.restaurants,
          date: formatDate(action.date),
          displayDate: action.displayDate,
        },
      };
    case 'SET_EAT_TRAVELER_TIME':
      return {
        ...state,
        restaurants: {
          ...state.restaurants,
          time: action.time,
        },
      };
    case 'SET_EAT_TRAVELER_PARTY_SIZE':
      return {
        ...state,
        restaurants: {
          ...state.restaurants,
          partySize: action.partySize,
        },
      };
    case 'SET_DEFAULT_STATUS':
      return {
        ...state,
        restaurants: {
          ...state.restaurants,
          isDefault: action.isDefault,
        },
      };
    default:
      return state;
  }
};
